export default function ServiceOverview() {
  return (
    <section id="service" className="py-24 bg-gradient-to-b from-[#4A3728] to-[#2D1F16]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-purple-200/20 rounded text-purple-200 text-xs font-medium">
            / SERVICE
          </div>
          <h2 className="text-5xl font-bold text-white mb-6 max-w-3xl">
            <a href="#service" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              複合機レンタルの新しいカタチ
            </a>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl leading-relaxed">
            本体料金不要で複合機をご利用いただけます。メンテナンス保守契約可能な月額定額制だから、
            予算管理も簡単。故障時の対応も迅速で、ビジネスを止めません。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="bg-gray-100 rounded-3xl p-8 aspect-square flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/e445b6fc60a221af2acbdd4745d241b1.jpg"
              alt="シャープ製レーザーカラー複合機"
              className="w-full h-full object-contain"
            />
          </div>

          <div>
            <div className="mb-8">
              <div className="text-7xl font-light text-white mb-4" style={{ fontFamily: 'serif' }}>
                ¥4,000<span className="text-3xl">〜</span>
              </div>
              <p className="text-white/70 text-base">
                月額定額制・保守メンテナンス込み<br />
                消耗品無料・故障時の代替機提供
              </p>
            </div>

            <button className="bg-white text-gray-900 px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              詳しく見る
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
